// Header Megamenu Images
{
  document.querySelectorAll('.outer-mega-menus').forEach(megaMenu => {
    let featuredImages = megaMenu.querySelector('.featured-images');
    let product_images_url = megaMenu.querySelector('.product_images_url');
    megaMenu.querySelectorAll('.widemenu__link').forEach(widemenuLink => {
      widemenuLink.addEventListener('mouseenter',(e) => {
        let imageUrl = widemenuLink.dataset.image;
        //console.log(imageUrl);
        product_images_url.src = imageUrl
        //console.log(product_images_url.src);
        featuredImages.classList.toggle('hidden',(imageUrl == ""));
      });
      widemenuLink.addEventListener('mouseout',(e) => {
        featuredImages.classList.add('hidden');
        product_images_url.src = '';
      });
    });
  });
}

$("#top-search-link").click(function(){
$(".search-container").toggle();
});

$('.list_collections').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 979,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
     {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

// $('.testimonial_thumbnail_slides').slick({
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   asNavFor: '.testimonial_content_slides',
//   dots: false,
//   centerMode: false,
//   focusOnSelect: true,
//    responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 4,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });
// $('.testimonial_content_slides').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay:true,
//   arrows: false,
//   fade: true,
//   infinite: false,
//   speed: 2000,
//   // asNavFor: '.testimonial_thumbnail_slides',
//     // prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
//     // nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
  
// });
$('.mobile_service_section').slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

function updateHeaderHeight() {
  const header = document.getElementById('header');

  if (header) {
    document.documentElement.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
}

updateHeaderHeight();
window.addEventListener('resize', updateHeaderHeight);